import React, { useState } from 'react';
import { StyledShareButton } from '../styles';
import { IMAGE_ROOT } from 'src/utils/constants';
import Portal from 'src/components/Portal';
import { E_POPUP_STATE } from 'src/utils/enum';
import LeafletSharePopup from './LeafletSharePopup';
import SwiperCore from 'swiper';
import { TLeafletItem } from 'src/types/types';

type TProps = {
  setGaEvent: (title: string) => void;
  contentSwiper?: SwiperCore;
  leafletData: TLeafletItem;
};

/**
 * @name 전단 공유 아이콘
 **/
function ShareButton(props: TProps): React.ReactElement {
  const [isOpen, setIsOpen] = useState<E_POPUP_STATE>(E_POPUP_STATE.NONE);

  // 공유하기 버튼 클릭
  const handleClickShareButton = () => {
    props.setGaEvent('공유하기 아이콘');
    setIsOpen(E_POPUP_STATE.OPEN);
  };

  const tabIndex =
    (props.contentSwiper && props.contentSwiper?.realIndex + 1) || 0;

  // 카카오톡 공유 이미지 생성
  const kakaoShareImage = props.leafletData.share_img_url
    ? props.leafletData.share_img_url
    : `${IMAGE_ROOT}/leaflet/leaflet_share_03.jpg`;

  return (
    <>
      <StyledShareButton>
        <button title="공유하기" onClick={handleClickShareButton}>
          <img src={`${IMAGE_ROOT}/leaflet/common/btn_share_gray.png`} alt="" />
        </button>
      </StyledShareButton>
      {/* 공유하기 팝업 */}
      {isOpen === E_POPUP_STATE.OPEN && (
        <Portal id="leafletSharePopup" isOpen={isOpen === E_POPUP_STATE.OPEN}>
          <LeafletSharePopup
            isOpen={isOpen}
            onClose={() => setIsOpen(E_POPUP_STATE.CLOSE)}
            tabIndex={tabIndex}
            kakaoShareImage={kakaoShareImage}
          />
        </Portal>
      )}
    </>
  );
}

export default ShareButton;
